import {
  getLocalStorageValue,
  setLocalStorageValue,
  SEEDANCE_STORAGE_KEYS,
} from './seedanceStorage';

/** 任务列表 task_id → 用户自定义任务名 */
export type TaskNameMap = Record<string, string>;

/** 任务名最大长度，避免本地缓存被异常输入撑大 */
export const TASK_NAME_MAX_LENGTH = 60;

function normalizeTaskId(value: unknown): string | null {
  if (value == null) return null;
  const id = String(value).trim();
  return id.length > 0 ? id : null;
}

export function loadTaskNameMap(): TaskNameMap {
  const raw = getLocalStorageValue(SEEDANCE_STORAGE_KEYS.taskNameMap);
  if (!raw.trim()) return {};
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object') return {};
    const map: TaskNameMap = {};
    for (const [taskId, value] of Object.entries(parsed as Record<string, unknown>)) {
      const key = normalizeTaskId(taskId);
      if (!key) continue;
      if (typeof value === 'string' && value.trim()) {
        map[key] = value.trim().slice(0, TASK_NAME_MAX_LENGTH);
      }
    }
    return map;
  } catch {
    return {};
  }
}

export function getTaskName(taskId: string): string {
  const key = normalizeTaskId(taskId);
  if (!key) return '';
  return loadTaskNameMap()[key] ?? '';
}

/** 保存任务名；传入空串等价于清除该任务的自定义名。返回更新后的整张映射。 */
export function saveTaskName(taskId: string, name: string): TaskNameMap {
  const key = normalizeTaskId(taskId);
  if (!key) return loadTaskNameMap();

  const map = loadTaskNameMap();
  const next = name.trim().slice(0, TASK_NAME_MAX_LENGTH);
  if (next) {
    map[key] = next;
  } else {
    delete map[key];
  }
  setLocalStorageValue(SEEDANCE_STORAGE_KEYS.taskNameMap, JSON.stringify(map));
  return map;
}
